<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div data-html2canvas-ignore="true">
    <v-footer app class="white--text trade-blue font-weight-light" color="#1f3c5f">
      <span class="ml-5 caption">&copy; {{ new Date().getFullYear() }} </span>
      <span class="ml-3 caption d-none d-sm-flex"> v{{ version }}</span>
      <span v-if="this.$store.state.app.callsPending > 0" class="yellow--text caption">
        [{{ this.$store.state.app.callsPending }}]</span
      >

      <v-spacer></v-spacer>

      <template
        v-if="
          $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
            .markets_count > 0 ||
            $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
              .products_count > 0
        "
      >
        <span class="yellow--text caption">
          <v-icon class="yellow--text caption">mdi-earth</v-icon>
          {{
            $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
              .markets_count
          }}
        </span>

        <span class="yellow--text caption">
          <v-icon class="yellow--text caption">mdi-dolly</v-icon>
          {{
            vFmt(
              $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
                .products_count,
              0,
            )
          }}
        </span>

        <span class="yellow--text caption">
          <v-icon class="yellow--text caption">mdi-sigma</v-icon>
          {{
            vFmt(
              $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
                .combinations,
              0,
            )
          }}
        </span>
      </template>

      <span
        class="yellow--text caption ml-3"
        v-if="
          $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
            .C_Code.length === 1
        "
        >{{
          codeToMarket(
            $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
              .C_Code[0],
          )
        }}</span
      >

      <span
        class="yellow--text caption ml-3"
        v-if="
          $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
            .HS6_Code.length === 1
        "
        >[{{ single_product }}] -
        {{ this.hs6_codeToDescription(this.single_product).substring(0, 120) }}...</span
      >
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="$store.state.excel_report_generation_in_progress === true">
        <template v-slot:activator="{on}">
          <v-icon v-on="on" class="iconPM yellow--text mr-2">mdi-microsoft-excel</v-icon>
        </template>
        <span>Excel document being prepared.</span></v-tooltip
      >

      <v-tooltip bottom v-if="$store.state.word_report_generation_in_progress === true">
        <template v-slot:activator="{on}">
          <v-icon v-on="on" class="iconPM yellow--text mr-2">mdi-microsoft-word</v-icon>
        </template>
        <span>Word document being prepared</span></v-tooltip
      >

      <v-tooltip bottom v-if="$store.state.email_report_generation_in_progress === true">
        <template v-slot:activator="{on}">
          <v-icon v-on="on" class="iconPM yellow--text mr-2">mdi-email</v-icon>
        </template>
        <span>Document being prepared and will be deliverd via email</span>
      </v-tooltip>

      <span class="yellow--text mr-6">
        |{{ $store.state.app.user_server_message }}|
      </span>
      <span></span>
      <span>
        {{
          $store.state.tradeDSM.dsm_filter_setttings.Filters.META.report_type_to_generate
        }}
      </span>
    </v-footer>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'footerBar',
  computed: {
    ...mapGetters(['is_run_cube_valid', 'single_product']),
    version() {
      return `[${process.env['VUE_APP_DATE']}(${
        process.env['VUE_APP_BACKEND_VERSION']
      })]}`;
    },
  },
};
</script>

<style scoped>
.iconPM {
  animation: blink 3s ease-in infinite;
}

@keyframes blink {
  from,
  to {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
</style>
